import React, { useEffect, useState } from 'react'
import './AdminTeamList.css'
import { NavLink } from 'react-router-dom'
import AdminNavigation from './AdminNavigation'
import { useParams } from 'react-router-dom'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Modal from '../../shared/components/UIElements/Modal'
import { useHttpClient } from '../../shared/hooks/http-hook'
//import Button from '../../shared/components/UIElements/Button'
import AdminButton from '../../shared/components/UIElements/AdminButton'

const AdminTeamList = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [teamId, setTeamId] = useState()
	const [loadedTeams, setLoadedTeams] = useState()
	const [isCurrent, setIsCurrent] = useState()
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	const [gamesExistModal, setGamesExistModal] = useState(false)
	const [allGames, setAllGames] = useState([])
	const [teamDeleted, setTeamDeleted] = useState()
	const [teamToDelete, setTeamToDelete] = useState()
	const leagueName = useParams().leagueName
	const divisionName = useParams().divisionName
	const session = useParams().session
	const year = useParams().year

	//First, lets tap into the following route on the backend to get all teams in league:
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			setTeamDeleted(false)
			if (divisionName) {
				console.log('we have a division name!')
				try {
					const response = await fetch(
						`${process.env.REACT_APP_BACKEND_URL}/admin/${leagueName}/${divisionName}/${session}/${year}/teams`,
					)

					const responseData = await response.json()

					if (!response.ok) {
						throw new Error(responseData.message)
					}

					setLoadedTeams(responseData.listOfTeams)
					setIsCurrent(responseData.isCurrent)
					setIsLoading(false)
				} catch (err) {
					setError(err.message)
				}
			}

			if (!divisionName) {
				//console.log('we DO NOT have a division name!')
				try {
					const response = await fetch(
						`${process.env.REACT_APP_BACKEND_URL}/admin/${leagueName}/${session}/${year}/teams`,
					)

					const responseData = await response.json()

					if (!response.ok) {
						throw new Error(responseData.message)
					}

					setLoadedTeams(responseData.listOfTeams)
					setIsCurrent(responseData.isCurrent)
					setIsLoading(false)
				} catch (err) {
					setError(err.message)
				}
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [leagueName, session, setLoadedTeams, year, teamDeleted])

	const errorHandler = () => {
		setError(null)
	}

	const showDeleteWarningHandler = async (e, teamname) => {
		console.log('e: ' + e.target.id)
		const value = e.target.id
		setTeamToDelete(teamname)
		setTeamId(loadedTeams[value]._id)
		console.log('fucking teamId: ' + loadedTeams[value]._id)
		const teamId = loadedTeams[value]._id
		//First, we need to go out and see if this team has any games scheduled
		try {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${teamId}/doesTeamHaveGames`,
			)

			const responseData = await response.json()
			console.log('responseData: ' + JSON.stringify(responseData))
			console.log('responseData LENGTH: ' + responseData.allGames.length)
			if (!response.ok) {
				throw new Error(responseData.message)
			}
			if (responseData.allGames.length === 0) {
				console.log('looks like theres no games')
				setShowConfirmModal(true)
			} else {
				console.log('we DO have games')
				setGamesExistModal(true)
			}
			setIsLoading(false)
		} catch (err) {
			setError(err.message)
		}
	}

	const cancelDeleteHandler = () => {
		setShowConfirmModal(false)
		setGamesExistModal(false)
	}

	//console.log('team right here: ' + teamId)
	const confirmDeleteHandler = async () => {
		setShowConfirmModal(false)
		console.log('teamId: ' + teamId)
		//
		//
		//
		//
		if (allGames.length > 0) {
			console.log('this team has games.  they must be deleted first')
		}
		//
		//
		if (allGames.length === 0) {
			try {
				await sendRequest(
					process.env.REACT_APP_BACKEND_URL + `/admin/${teamId}/removeTeam`,
					'DELETE',
				)
			} catch (err) {}
			setTeamDeleted(true)
			console.log('DELETING...')
		}
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			<Modal
				show={showConfirmModal}
				onCancel={cancelDeleteHandler}
				header='Are you sure?'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Are you sure you wish to delete <h1>{teamToDelete}</h1>
						</p>
						<p className='modalText'>
							This will also delete all the rostered players from the team.
						</p>
						<br></br>
						<button
							class='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelDeleteHandler}
						>
							CANCEL
						</button>
						<button
							className='cancelDeleteButtons buttonButton'
							style={{ color: 'red' }}
							danger
							onClick={confirmDeleteHandler}
						>
							DELETE TEAM
						</button>
					</React.Fragment>
				}
			></Modal>
			<Modal
				show={gamesExistModal}
				onCancel={cancelDeleteHandler}
				header='WE HAVE GAMES FOR THIS TEAM!'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							It looks like there are games scheduled for{' '}
							<h1>{teamToDelete}</h1>
						</p>
						<p className='modalText' style={{ color: 'red' }}>
							Delete this teams games, then come back and delete the team.
						</p>
						<br></br>
						<button
							class='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelDeleteHandler}
						>
							OK
						</button>
					</React.Fragment>
				}
			></Modal>
			{!isLoading && loadedTeams && (
				<div className='Teams'>
					<AdminNavigation />
					<h1>{leagueName} Teams</h1>
					<h1>{divisionName && divisionName + ' ' + 'Division'}</h1>
					<h2>
						{session} {year}
					</h2>
					{/* =====================================================
	MOBILE TEAM CARDS
	Only displayed at 440px and below
===================================================== */}

					<div className='mobileTeamCards'>
						{loadedTeams.map((team, key) => {
							return (
								<div className='mobileTeamCard' key={team._id}>
									{/* LEFT SIDE */}
									<div className='mobileTeamCardInfo'>
										<h2>{team.teamName}</h2>

										<div className='mobileAssignedPlayers'>
											<span>Assigned Players:</span>
											<strong>{team.assignedPlayers}</strong>
										</div>
									</div>

									{/* RIGHT SIDE */}
									<div className='mobileTeamCardActions'>
										{!divisionName && (
											<NavLink
												className='mobileTeamAction mobilePlayersButton'
												to={`/admin/${leagueName}/${session}/${year}/${team.teamName}/players`}
												exact
											>
												Players
											</NavLink>
										)}

										{divisionName && (
											<NavLink
												className='mobileTeamAction mobilePlayersButton'
												to={`/admin/${leagueName}/${divisionName}/${session}/${year}/${team.teamName}/players`}
												exact
											>
												Players
											</NavLink>
										)}

										{team.wins < 1 && team.losses < 1 && team.ties < 1 && (
											<NavLink
												className='mobileTeamAction mobileUploadTeamButton'
												to={`/admin/${team._id}/${team.teamName}/${year}/${session}/${leagueName}/uploadTeam`}
												exact
											>
												Upload Team
											</NavLink>
										)}

										<div className='mobileTeamSmallActions'>
											<NavLink
												className='mobileTeamAction'
												to={`/admin/${team._id}/teamPhoto`}
												exact
											>
												Team Photo
											</NavLink>

											{isCurrent && (
												<NavLink
													className='mobileTeamAction'
													to={`/admin/${leagueName}/${session}/${year}/updateTeam/${team._id}`}
													exact
												>
													Edit
												</NavLink>
											)}
										</div>

										{isCurrent && (
											<button
												className='mobileTeamAction mobileTeamDeleteButton'
												id={key}
												onClick={(e) =>
													showDeleteWarningHandler(e, team.teamName)
												}
											>
												Delete
											</button>
										)}
									</div>
								</div>
							)
						})}

						{isCurrent && !divisionName && (
							<div className='mobileAddTeamButton'>
								<AdminButton
									to={`/admin/${leagueName}/${session}/${year}/newTeam`}
									exact
								>
									+ &nbsp; Add Team(s)
								</AdminButton>
							</div>
						)}

						{isCurrent && divisionName && (
							<div className='mobileAddTeamButton'>
								<AdminButton
									to={`/admin/${leagueName}/${divisionName}/${session}/${year}/newTeam`}
									exact
								>
									+ &nbsp; Add Team(s)
								</AdminButton>
							</div>
						)}
					</div>
					<table id='teams'>
						<thead>
							<tr>
								<th>Team Name</th>
								<th>Assigned Players</th>
								<th></th>
								<th></th>
								<th></th>
								{isCurrent && <th style={{ width: '25%' }}></th>}
								{isCurrent && <th></th>}
							</tr>
						</thead>
						<tbody>
							{loadedTeams.map((team, key) => {
								return (
									<tr key={key}>
										<td>{team.teamName}</td>
										<td>{team.assignedPlayers}</td>
										<td>
											{!divisionName && (
												<NavLink
													className='navlinks'
													to={`/admin/${leagueName}/${session}/${year}/${team.teamName}/players`}
													exact
												>
													Players
												</NavLink>
											)}
											{divisionName && (
												<NavLink
													className='navlinks'
													to={`/admin/${leagueName}/${divisionName}/${session}/${year}/${team.teamName}/players`}
													exact
												>
													Players
												</NavLink>
											)}
										</td>
										<td>
											{team.wins < 1 && team.losses < 1 && team.ties < 1 && (
												<NavLink
													className='navlinks'
													to={`/admin/${team._id}/${team.teamName}/${year}/${session}/${leagueName}/uploadTeam`}
													exact
												>
													Upload Team
												</NavLink>
											)}
										</td>
										<td>
											<NavLink
												className='navlinks'
												to={`/admin/${team._id}/teamPhoto`}
												style={{ whiteSpace: 'nowrap' }}
												exact
											>
												Team Photo
											</NavLink>
										</td>
										{isCurrent && (
											<td>
												<NavLink
													className='navlinks'
													to={`/admin/${leagueName}/${session}/${year}/updateTeam/${team._id}`}
													exact
													style={{ whiteSpace: 'nowrap' }}
												>
													Edit Team
												</NavLink>
											</td>
										)}
										{isCurrent && (
											<td>
												<button
													className='buttonButton'
													style={{ color: 'red' }}
													id={key}
													onClick={(e) =>
														showDeleteWarningHandler(e, team.teamName)
													}
												>
													DELETE
												</button>
											</td>
										)}
									</tr>
								)
							})}
						</tbody>
						{isCurrent && !divisionName && (
							<div
								style={{
									width: '150%',
									marginTop: '2rem',
									marginBottom: '3rem',
									marginLeft: '1rem',
								}}
							>
								<AdminButton
									to={`/admin/${leagueName}/${session}/${year}/newTeam`}
									exact
								>
									Add Team(s)
								</AdminButton>
							</div>
						)}
						{isCurrent && divisionName && (
							<div
								style={{
									width: '150%',
									marginTop: '2rem',
									marginBottom: '3rem',
									marginLeft: '1rem',
								}}
							>
								<AdminButton
									to={`/admin/${leagueName}/${divisionName}/${session}/${year}/newTeam`}
									exact
								>
									Add Team(s)
								</AdminButton>
							</div>
						)}
					</table>
				</div>
			)}
			{!isLoading && !loadedTeams && (
				<div className='Teams'>
					<AdminNavigation />
					<h1>{leagueName} Teams</h1>
					<h2>
						{session} {year}
					</h2>
					<table id='teams'>
						<thead>
							<tr>
								<th>Team Name</th>
								<th>Assigned Players</th>
								<th></th>
								{isCurrent && <th></th>}
								{isCurrent && <th></th>}
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>NO TEAMS IN THIS LEAGUE YET</td>
							</tr>
						</tbody>
						{isCurrent && !divisionName && (
							<div
								style={{
									width: '150%',
									marginTop: '2rem',
									marginBottom: '3rem',
									marginLeft: '1rem',
								}}
							>
								<AdminButton
									to={`/admin/${leagueName}/${session}/${year}/newTeam`}
									exact
								>
									Add Team(s)
								</AdminButton>
							</div>
						)}
						{isCurrent && divisionName && (
							<div
								style={{
									width: '150%',
									marginTop: '2rem',
									marginBottom: '3rem',
									marginLeft: '1rem',
								}}
							>
								<AdminButton
									to={`/admin/${leagueName}/${divisionName}/${session}/${year}/newTeam`}
									exact
								>
									Add Team(s)
								</AdminButton>
							</div>
						)}
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default AdminTeamList
